import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">平台特色</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">为什么选择香蕉影视？四大核心优势打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((item, i) => (
            <div key={i} className="group bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-all duration-300 cursor-default">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}